var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 1H3C1.89543 1 1 1.89543 1 3V45C1 46.1046 1.89543 47 3 47H31C32.1046 47 33 46.1046 33 45V3C33 1.89543 32.1046 1 31 1Z",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1H27V5C27 5.53043 26.7893 6.03914 26.4142 6.41421C26.0391 6.78929 25.5304 7 25 7H11C10.4696 7 9.96086 6.78929 9.58579 6.41421C9.21071 6.03914 9 5.53043 9 5V1Z",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 7V3C40 2.46957 40.2107 1.96086 40.5858 1.58578C40.9609 1.21071 41.4696 1 42 1H44C44.5304 1 45.0391 1.21071 45.4142 1.58578C45.7893 1.96086 46 2.46957 46 3V7H40Z",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 38L43 47L39 38H47Z",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 7V38H47V7H39Z",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 28H47",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27H22",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 27H10",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 43H10",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11H10",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 35H16",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19H16",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18C25.6569 18 27 16.6569 27 15C27 13.3431 25.6569 12 24 12C22.3431 12 21 13.3431 21 15C21 16.6569 22.3431 18 24 18Z",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 42C25.6569 42 27 40.6569 27 39C27 37.3431 25.6569 36 24 36C22.3431 36 21 37.3431 21 39C21 40.6569 22.3431 42 24 42Z",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15H11C9.93913 15 8.92172 15.4214 8.17157 16.1716C7.42143 16.9217 7 17.9391 7 19V19C7 20.0609 7.42143 21.0783 8.17157 21.8284C8.92172 22.5786 9.93913 23 11 23H23C24.0609 23 25.0783 23.4214 25.8284 24.1716C26.5786 24.9217 27 25.9391 27 27C27 28.0609 26.5786 29.0783 25.8284 29.8284C25.0783 30.5786 24.0609 31 23 31H11C9.93913 31 8.92172 31.4214 8.17157 32.1716C7.42143 32.9217 7 33.9391 7 35V35C7 36.0609 7.42143 37.0783 8.17157 37.8284C8.92172 38.5786 9.93913 39 11 39H18",
    stroke: "#185ADB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.3a120462e0ca4e6693eb9a04e9013952.svg";
export { ForwardRef as ReactComponent };